import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ITagModel, ITagPutRequestModel, ITagType } from 'dist/lib-core-shared/lib/models/product/dto/tags/product-tags.model';
import { ProductTagsService } from 'lib-core-shared';

@Component({
  selector: 'app-edit-product-tag',
  templateUrl: './edit-product-tag.component.html',
  styleUrls: ['./edit-product-tag.component.scss']
})
export class EditProductTagComponent implements OnInit {
  public form: FormGroup;
  @Input() tagId?: number;
  @Output() closeModal = new EventEmitter<boolean>();
  tag?: ITagModel;
  isBusy: boolean = true;
  spinnerText: string = 'LDG';
  fb: any;
  @Output() saveCloseModal = new EventEmitter<any>();
  @Input() tagTypes!: ITagType[];

  constructor(private productTagsService: ProductTagsService) {
    this.form = new FormGroup({
      tagType: new FormControl(null, [Validators.required]),
      tagTitleEn: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      tagTitleUs: new FormControl(null, [Validators.maxLength(255)]),
      tagTitleFr: new FormControl(null, [Validators.maxLength(255)]),
      tagTitleNl: new FormControl(null, [Validators.maxLength(255)]),
      tagTitleDe: new FormControl(null, [Validators.maxLength(255)])
    })
  }

  ngOnInit(): void {
    if (this.tagId) {
      this.productTagsService.getTagById(this.tagId).subscribe((tag: ITagModel) => {
        this.tag = tag;
        this.populateFormValues();
      })
    }
  }

  populateFormValues() {
    if (this.form && this.tag) {
      const en = this.tag.titles.filter(t => t.languageCode === "EN")[0];
      const us = this.tag.titles.filter(t => t.languageCode === "US")[0];
      const fr = this.tag.titles.filter(t => t.languageCode === "FR")[0];
      const nl = this.tag.titles.filter(t => t.languageCode === "NL")[0];
      const de = this.tag.titles.filter(t => t.languageCode === "DE")[0];
  
      this.form.controls.tagTitleEn.setValue(en && en.title ? en.title : '');
      this.form.controls.tagTitleUs.setValue(us && us.title ? us.title : '');
      this.form.controls.tagTitleFr.setValue(fr && fr.title ? fr.title : '');
      this.form.controls.tagTitleNl.setValue(nl && nl.title ? nl.title : '');
      this.form.controls.tagTitleDe.setValue(de && de.title ? de.title : '');

      if (this.tagTypes) {
        const tagTypeObj = this.tagTypes.filter(t => t.code === this.tag?.tagTypeCode)[0];
        this.form.controls.tagType.setValue(tagTypeObj);
      }
    }

    this.isBusy = false;
  }

  close() {
    this.closeModal.emit(true);
  }

  save() {
    if (this.form.valid && this.tagId) {
      delete this.fb;
      this.spinnerText = 'SVG';
      this.isBusy = true;
      
      let dto: ITagPutRequestModel = {
        id: this.tagId,
        tagTypeCode: this.form.value.tagType.code,
        titles: this.dtoTitlesMapper(this.form.value)
      }
      
      if (dto && dto.id && dto.tagTypeCode && dto.titles && dto.titles.length) {
        this.productTagsService.editTag(dto).subscribe((res: any) => {
          if (res) {
            this.isBusy = false;
            this.saveCloseModal.emit({mode: 'edit', response: res});
          }
        }, error => {
          if (error) {
            this.isBusy = false;

            if (error.status !== 404) {
              this.fb = {
                text: error.error,
                error: error
              };

              setTimeout(() => {
                let errorCard = document.getElementsByTagName('lib-error');
                errorCard[0].scrollIntoView({block: "end", inline: "center", behavior: "smooth"});
              }, 0)
            }
          }
        })
      }
    }
  }

  dtoTitlesMapper(formValues: any) {
    let arr = [];

    if (formValues && formValues.tagTitleEn) {
      arr.push({languageCode: "EN", title: formValues.tagTitleEn});

      if (formValues.tagTitleUs) {
        arr.push({languageCode: "US", title: formValues.tagTitleUs});
      }

      if (formValues.tagTitleFr) {
        arr.push({languageCode: "FR", title: formValues.tagTitleFr});
      }

      if (formValues.tagTitleNl) {
        arr.push({languageCode: "NL", title: formValues.tagTitleNl});
      }

      if (formValues.tagTitleDe) {
        arr.push({languageCode: "DE", title: formValues.tagTitleDe});
      }
    }

    return arr;
  }

  public getErrorMsgText():string {
    return this.fb?.text ? this.fb.text : '';
  }
}
